module.exports = __webpack_public_path__ + "fonts/roboto-v15-latin-regular.38861cba61c66739c1452c3a71e39852.ttf?";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.ttf
// module id = 913
// module chunks = 6